export const teamsExperience = {
  routeHash: '#/teams',
  entryPoint: 'teams',
  headerButtonLabel: 'Teams',
  headerButtonAriaLabel: 'Open Teams support chat in a new tab',
  pageTitle: 'Teams Support',
  pageSubtitle: 'Microsoft Teams help desk',
  agentName: 'Teams Support Agent',
  welcomeMessage: "Hi 👋 I'm the Microsoft support agent for Teams. How can I help with your Teams for personal use — chats, calls, meetings, or sign-in?",
  handoffMessage: 'Connecting to live agent...',
  preChatSurveyMessage: 'Please complete the pre-chat survey before I connect you to a live agent.',
  handoffConnectedMessage: 'Connected to live agent.',
  liveSessionNotResumableMessage: "This live support chat can't be resumed after the page reloads. Select New Chat to start again.",
  handoffMissingConfigMessage: 'Live chat is not configured for this route.',
  liveAgentName: 'Live support agent',
  liveAgentAvatar: 'LS',
  omnichannelSdkUrl: 'https://unpkg.com/@microsoft/omnichannel-chat-sdk@1.10.10/lib/index.umd.js',
  errorPrefix: 'Sorry, something went wrong.',
  askPlaceholder: 'Ask your question',
  sendButtonLabel: 'Send',
  userName: 'You',
  userAvatar: 'Y',
  agentAvatar: 'TS',
  logoText: 'T',
  theme: {
    purple: '#5b5fc7',
    purpleDark: '#464775',
    purpleMedium: '#6264a7',
    pageBackground: '#faf9f8',
    text: '#242424',
    link: '#115ea3',
    border: '#e1dfdd',
    systemBackground: '#fff4ce',
    systemBorder: '#f3d675',
  },
};
